import React from "react";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import GroupMultiSelect from "@/components/GroupMultiSelect";

// Assignment control for Document Depot forms + handouts: entire team or specific groups.
// value = { assign_type, subgroup_ids }
export default function AssignmentPicker({ value, onChange, subs = [], testId = "assign" }) {
  const set = (patch) => onChange({ ...value, ...patch });
  return (
    <div className="space-y-2">
      <Select value={value.assign_type} onValueChange={(v) => set({ assign_type: v, subgroup_ids: [] })}>
        <SelectTrigger data-testid={`${testId}-type`}><SelectValue /></SelectTrigger>
        <SelectContent>
          <SelectItem value="team" data-testid={`${testId}-type-team`}>Entire team</SelectItem>
          <SelectItem value="groups" data-testid={`${testId}-type-groups`}>Specific groups</SelectItem>
        </SelectContent>
      </Select>
      {value.assign_type === "groups" && (
        <GroupMultiSelect subs={subs} value={value.subgroup_ids} onChange={(ids) => set({ subgroup_ids: ids })} testId={`${testId}-groups`} />
      )}
    </div>
  );
}
